// test1991
(1991 && 0);
